﻿import { LiveDataSet, Status } from "../../API/LiveData/LiveDataSet";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { ILiveDataListener, ILiveDataListenerContext } from "../../ILiveDataListener";
import { PopupChartable } from "../../PopupChartable";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class LedBox extends PopupChartable implements ILiveDataListener {
    private wrap: JQuery;
    private led: JQuery;
    private text: JQuery;

    private regexGreen = /^0/;
    private regexRed = /^1/;
    private regexAmber = /^2/;

    private textGreen: string = "TEMPSC Available";
    private textRed: string = "TEMPSC Not Available";
    private textAmber: string = "TEMPSC Not Available";
    private textGrey: string = "TEMPSC Status Unknown";


    constructor(page: ISiteObservationsPage, container: JQuery, valueFormatter: IStationValueFormatter, ctx: ILiveDataListenerContext) {

        super(page.mainSite);

        this.valueFormatter = valueFormatter;
        this.station = page.station.Station;
        this.warningGroup = page.warningGroup;

        this.wrap = $('<div></div>').addClass('midi_siteObsPage_LED_wrap').attr('title', 'The TEMPSC LED shows red if: \n • wind speed (10-minute mean) is greater than 30 kts, and \n • wind direction (10-minute mean) is between 135 and 315 degrees (exclusive), and \n • maximum wave height is greater than 6 m.\n otherwise it shows green.').appendTo(container);
        this.led = $('<span>').addClass('midi_siteObsPage_LED').appendTo(this.wrap);
        this.text = $('<span>').addClass('midi_siteObsPage_LED_text').appendTo(this.wrap);

        if (page.mainSite.liveDataManager.latestData) {
            this.liveDataChanged(page.mainSite.liveDataManager.latestData, ctx);
        }
    }

    public liveDataChanged(latestData: LiveDataSet, ctx: ILiveDataListenerContext): void {
        var valueObject: IStationValueObject = this.valueFormatter.format(latestData.Stations[this.station.Id], this.warningGroup);

        this.setSensor(this.valueFormatter.getSensorId() ?? valueObject.Sensor);
        this.setTimestamp(valueObject.Timestamp);
        // this.wrap.attr('title', 'Timestamp: ' + moment(moment.utc(valueObject.Timestamp)).tz(this.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm") + '. Click for parameter popup.')

        ctx.valueChanged(valueObject);

        const resRegexGreen = this.regexGreen.exec(valueObject.Value);
        const resRegexRed = this.regexRed.exec(valueObject.Value);
        const resRegexAmber = this.regexAmber.exec(valueObject.Value);

        if (resRegexGreen !== null && resRegexGreen.length > 0) {
            this.led.attr("data-colour", "green");
            this.text.text(this.textGreen);
        } else if (resRegexRed !== null && resRegexRed.length > 0) {
            this.led.attr("data-colour", "red");
            this.text.text(this.textRed);
        } else if (resRegexAmber !== null && resRegexAmber.length > 0) {
            this.led.attr("data-colour", "amber");
            this.text.text(this.textAmber);
        } else {
            this.led.attr("data-colour", "grey");
            this.text.text(this.textGrey);
        }

        if (valueObject.Status === null || valueObject.Status === Status.Expired) {

            // no valid data -> hide units and remove any colour coding
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');

            this.wrap.addClass('midi_siteObsPage_expiring');

            return;
        }

        if (valueObject.Status == Status.Good) {
            this.wrap.removeClass('midi_siteObsPage_expiring');
        } else {
            this.wrap.addClass('midi_siteObsPage_expiring');
        }

        // by this point we will be showing some data

        if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.addClass('midi_siteObsPage_exceeded_threshold_3');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.wrap.addClass('midi_siteObsPage_exceeded_threshold_2');
        } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
            this.wrap.addClass('midi_siteObsPage_exceeded_threshold_1');
        } else {
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_1');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_2');
            this.wrap.removeClass('midi_siteObsPage_exceeded_threshold_3');
        }
    }
}